import React from 'react';

const  IconResilience = () => {

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M15.5146 2.27148C16.2088 2.27184 16.8686 2.50272 17.2998 2.91895C19.3446 4.89272 22.8426 7.25591 27.7793 7.12305C28.757 7.09678 29.5104 7.76561 29.4863 8.58496C29.4106 11.1634 28.9728 15.6661 27.082 20.1113C25.1951 24.5475 21.8703 28.9086 16.0176 31.2715C15.7003 31.3995 15.3311 31.3993 15.0137 31.2715C9.14656 28.9084 5.81401 24.5469 3.92285 20.1104C2.02779 15.6646 1.58949 11.161 1.51367 8.58301C1.48987 7.76416 2.24282 7.09641 3.21973 7.12305C8.17155 7.25802 11.6796 4.89203 13.7295 2.91699C14.161 2.50123 14.8205 2.27117 15.5146 2.27148Z" stroke="currentColor"/>
            <path d="M10 16L14 20L22 12" stroke="currentColor" strokeLinecap="round"/>
        </svg>
    )

}

export default IconResilience;
